module.exports = __webpack_public_path__ + "img/IO.da2dbba4.svg";